export const PAYMENT_RESULT_MODAL_ID = 'payment-result-modal'
const PAYMENT_RESULT_OPEN_EVENT = 'payment-result:open'

export type PaymentResultStatus = 'success' | 'fail'
export type PaymentPurchaseType = 'subscription' | 'tokens'
export type PaymentResultReopenSource = 'insufficient-balance'

export type PaymentResultOpenDetail = {
    status: PaymentResultStatus
    purchaseType: PaymentPurchaseType
    purchaseLabel: string
    amount: number
    tokens?: number
    failReason?: string
    reopenSource?: PaymentResultReopenSource
    onSettledSuccess?: () => void
}

export const openPaymentResultModal = (detail: PaymentResultOpenDetail) => {
    if (typeof document === 'undefined') return

    document.dispatchEvent(new CustomEvent<PaymentResultOpenDetail>(PAYMENT_RESULT_OPEN_EVENT, { detail }))
}

export const listenPaymentResultModalOpen = (handler: (detail: PaymentResultOpenDetail) => void) => {
    if (typeof document === 'undefined') return () => undefined

    const listener = (event: Event) => {
        const customEvent = event as CustomEvent<PaymentResultOpenDetail>
        if (!customEvent.detail) return
        handler(customEvent.detail)
    }

    document.addEventListener(PAYMENT_RESULT_OPEN_EVENT, listener)
    return () => {
        document.removeEventListener(PAYMENT_RESULT_OPEN_EVENT, listener)
    }
}

export const closePaymentResultModal = () => {
    if (typeof document === 'undefined') return

    const checkbox = document.getElementById(PAYMENT_RESULT_MODAL_ID) as HTMLInputElement | null
    if (!checkbox) return

    checkbox.checked = false
}

export const isPaymentResultModalOpen = () => {
    if (typeof document === 'undefined') return false

    const checkbox = document.getElementById(PAYMENT_RESULT_MODAL_ID) as HTMLInputElement | null
    return Boolean(checkbox?.checked)
}
